import React, { useState, useEffect } from 'react';
import { Button, Card, Modal, CardContent, Radio, RadioGroup, FormControlLabel } from '@mui/material';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { TextField } from '@mui/material';
import './DateRangeButton';
import dayjs from 'dayjs';
import './DateRangeButton.scss';
import { setDateRange , setSelectedRadioOption } from '../../redux/actions/dateRangeActions';
import { useDispatch, useSelector } from 'react-redux';
import { startDateRangeSaga, endDateRangeSaga } from '../../redux/saga/dateRangeSelector';
import {DATE_RANGE_OPTIONS, APPLY_TEXT, CANCEL_TEXT} from '../../constants/dateRangeButtonConstants';
import { BUTTON_CLICK, DATE_RANGE_BUTTON, DATE_RANGE_UPDATE } from '../../constants/mixPannelConstants';
import { N_A } from '../../constants/commonConstants';
import { updateMixPanel } from '../../redux/actions/merchantAction';

const DateRangeButton = ({ pageName}) => {

    const [openCalendarSelectionOption, setOpenCalendarSelectionOption] = useState(false);
    const [selectedOption, setSelectedOption] = useState('Last Week');
    const [showCalendar, setShowCalendar] = useState(false);
    const [startDate, setStartDate] = useState(null); // startDate is local state
    const [endDate, setEndDate] = useState(null); // endDate is local state
	const [buttonLabel, setButtonLabel] = useState(''); // to set name on button
    const [isCustomDatesApplied, setIsCustomDatesApplied] = useState(false); //flag to check if custom dates cliked
    const [startDateError, setStartDateError] = useState(false);
    const [endDateError, setEndDateError] = useState(false);
    const today = dayjs();
    const dispatch = useDispatch();
 
    const formatDateRangeLabel = (startDate, endDate) => {

		const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

		const formatDate = (dateString) => {
			if (typeof dateString !== 'string') return null; // Check if the input is a string
			const [month, day, year] = dateString.split('-');
			const monthName = months[parseInt(month) - 1];
			return `${monthName} ${parseInt(day)}, ${year}`;
		};
		const formattedStartDateLabel = formatDate(startDate);
		const formattedEndDateLabel = formatDate(endDate);
		return `${formattedStartDateLabel} - ${formattedEndDateLabel}`;
    };
 
	const sessionstartdate = sessionStorage.getItem('startDate'); 
	const sessionenddate = sessionStorage.getItem('endDate'); 
	const sessionselectedoption = sessionStorage.getItem('selectedOption'); 
	const globalStartDate = useSelector(startDateRangeSaga);
    const globalEndDate = useSelector(endDateRangeSaga);

	useEffect(()=>{
			if(startDate && endDate && !showCalendar){
				dispatch(updateMixPanel({type: BUTTON_CLICK, value: {
					buttonName: DATE_RANGE_BUTTON,
					outcome: openCalendarSelectionOption? 'Date picker opened' : 'Date picker closed',
					EventTime: new Date().toUTCString(),
					startTime:new Date(startDate).toLocaleDateString(),
					endTime: new Date(endDate).toLocaleDateString(),
					PageName: pageName,
					timeSpent: N_A
				}, check: 'no'}))}
			}
			
		,[openCalendarSelectionOption]);


	useEffect(()=>{
		// console.log('DATE ',startDate, typeof(startDate),endDate, typeof(endDate), openCalendarSelectionOption)
		if(startDate !== null && endDate !== null && !showCalendar){
			dispatch(updateMixPanel({type: DATE_RANGE_UPDATE, value: {
				buttonName: DATE_RANGE_BUTTON,
				EventTime: new Date().toUTCString(),
				startDate: typeof(startDate) ==='object'? new Date(startDate.toLocaleDateString()).toUTCString(): new Date(startDate).toUTCString(),
				endDate: typeof(endDate) ==='object'? new Date(endDate.toLocaleDateString()).toUTCString(): new Date(endDate).toUTCString(),
				PageName: pageName,
				timeSpent: N_A
			}, check: 'page'}));
		}
		}
		,[startDate,endDate,showCalendar]);

    useEffect(() => {
		if(sessionstartdate && sessionenddate && sessionselectedoption){
			setStartDate(sessionstartdate);
            setEndDate(sessionenddate);	
            setButtonLabel(formatDateRangeLabel(sessionstartdate, sessionenddate));
			setSelectedOption(sessionselectedoption);
			dispatch(setSelectedRadioOption(sessionselectedoption));
		}
		else {
            lastweekDateRangeCalculator();
        }									
    } , [dispatch]);    
 
    const handleButtonClick = () => {
        if (showCalendar === true){
            setOpenCalendarSelectionOption(!openCalendarSelectionOption);
        }
        setOpenCalendarSelectionOption(!openCalendarSelectionOption);
		setStartDate(sessionstartdate);
		setEndDate(sessionenddate);
    }
 
	function formatDate(dateString) {
		const dateObject = new Date(dateString);
		const month = String(dateObject.getMonth() + 1).padStart(2, '0');
		const day = String(dateObject.getDate()).padStart(2, '0');
		const year = dateObject.getFullYear();
		return `${month}-${day}-${year}`;
	}

    const lastweekDateRangeCalculator = () => {
        const lastWeekEnd = today.subtract(1, 'day'); // End date is yesterday
        const lastWeekStart = lastWeekEnd.subtract(6, 'day'); // Start date is 6 days before yesterday
		const formattedStartDate = formatDate(lastWeekStart);
		const formattedEndDate = formatDate(lastWeekEnd);
		dispatch(setDateRange(formattedStartDate, formattedEndDate));
        setButtonLabel(formatDateRangeLabel(formattedStartDate, formattedEndDate));
        setStartDate(formattedStartDate);
        setEndDate(formattedEndDate);
		dispatch(setSelectedRadioOption(DATE_RANGE_OPTIONS.LAST_WEEK));
		setOpenCalendarSelectionOption(false);
    }
    
    const handleCancel = () => {
        setShowCalendar(false);
        setOpenCalendarSelectionOption(false);
		dispatch(setDateRange (globalStartDate, globalEndDate));
    }
    
    const handleradioClick= (e)=> {
        if(isCustomDatesApplied === true) {
            setOpenCalendarSelectionOption(!openCalendarSelectionOption);
            setShowCalendar(true);
        } else {
            if(e.target.value === DATE_RANGE_OPTIONS.CUSTOM_DATES) {
                setOpenCalendarSelectionOption(!openCalendarSelectionOption);
                setShowCalendar(true);
            }
        }
        e.stopPropagation();
    }
 
    const handleClose = () => {  //background modalClose when Popup Opened
        setOpenCalendarSelectionOption(false);
        setShowCalendar(false);
		dispatch(setDateRange (globalStartDate, globalEndDate));
    };
      
    const handleRadioChange = (event) => {
        switch (event.target.value) {
          case DATE_RANGE_OPTIONS.THIS_WEEK:  
            handleDateChange(today.startOf('week'), new Date());
			setSelectedOption(DATE_RANGE_OPTIONS.THIS_WEEK);
			dispatch(setSelectedRadioOption(DATE_RANGE_OPTIONS.THIS_WEEK));
            break;
          case DATE_RANGE_OPTIONS.THIS_MONTH:
            handleDateChange(today.startOf('month'), new Date());
			setSelectedOption(DATE_RANGE_OPTIONS.THIS_MONTH);
			dispatch(setSelectedRadioOption(DATE_RANGE_OPTIONS.THIS_MONTH));
            break;
          case DATE_RANGE_OPTIONS.LAST_WEEK:
			lastweekDateRangeCalculator();
			setSelectedOption(DATE_RANGE_OPTIONS.LAST_WEEK);
			dispatch(setSelectedRadioOption(DATE_RANGE_OPTIONS.LAST_WEEK));
            break;
          case DATE_RANGE_OPTIONS.LAST_MONTH:
            handleLastMonth(today);
			setSelectedOption(DATE_RANGE_OPTIONS.LAST_MONTH);
			dispatch(setSelectedRadioOption(DATE_RANGE_OPTIONS.LAST_MONTH));
            break;
          case DATE_RANGE_OPTIONS.CUSTOM_DATES:
            setOpenCalendarSelectionOption(!openCalendarSelectionOption);
            setShowCalendar(true);
            break;
          default:
            setStartDate(null);
            setEndDate(null);
        }
    };
      
    const handleDateChange = (startDate, endDate) => {
        setStartDate(startDate.toDate());
        setEndDate(endDate);
		const formattedStartDate = formatDate(startDate);
		const formattedEndDate = formatDate(endDate);
        dispatch(setDateRange(formattedStartDate, formattedEndDate));
        setButtonLabel(formatDateRangeLabel(formattedStartDate, formattedEndDate));
        setOpenCalendarSelectionOption(!openCalendarSelectionOption);
    };
      
    const handleLastMonth = (today) => {
        const lastMonthStart = today.subtract(1, 'month').startOf('month');
        const lastMonthEnd = today.subtract(1, 'month').endOf('month');
        handleDateChange(lastMonthStart, lastMonthEnd.toDate());
    };
      
 
    const handleSubmit = (event) => {
        event.preventDefault();
        dispatch(setDateRange (startDate, endDate));
        setButtonLabel(formatDateRangeLabel(startDate, endDate));
        setShowCalendar(!showCalendar);
        setIsCustomDatesApplied(true);
		setSelectedOption(DATE_RANGE_OPTIONS.CUSTOM_DATES);
		dispatch(setSelectedRadioOption(DATE_RANGE_OPTIONS.CUSTOM_DATES));
    };

	const isSubmitDisabled = startDateError || endDateError;

	const handleStartDateChange = (date) => {
		const startDate = dayjs(date).toDate();
		const formattedStartDate = formatDate(startDate);
		setStartDate(formattedStartDate);
		sessionStorage.setItem('startDate', formattedStartDate);
		// Reset end date if it's after today or before the new start date
		const currentEndDate = sessionenddate ? dayjs(sessionenddate) : null;
		if (currentEndDate && (currentEndDate.isAfter(today) || currentEndDate.isBefore(startDate))) {
			setEndDateError(true);
		}else {
			setEndDateError(false);
		}
	  };

	  const handleEndDateChange = (date) => {
		const endDate = dayjs(date).toDate();
		const formattedEndDate = formatDate(endDate);
		setEndDate(formattedEndDate);
		sessionStorage.setItem('endDate', formattedEndDate);
		const newEndDate = dayjs(endDate);
		const newStartDate = dayjs(sessionstartdate);
		if (newStartDate.isAfter(newEndDate) || newEndDate.isAfter(today)) {
		  setEndDateError(true);
		} else {
		  setEndDateError(false);
		}
	  };

    const radioOptions = [
        { value: DATE_RANGE_OPTIONS.THIS_WEEK, label: DATE_RANGE_OPTIONS.THIS_WEEK },
        { value: DATE_RANGE_OPTIONS.THIS_MONTH, label: DATE_RANGE_OPTIONS.THIS_MONTH },
        { value: DATE_RANGE_OPTIONS.LAST_WEEK, label: DATE_RANGE_OPTIONS.LAST_WEEK },
        { value: DATE_RANGE_OPTIONS.LAST_MONTH, label: DATE_RANGE_OPTIONS.LAST_MONTH },
    ];

	const convertDateFormat = (dateString) => {
        const [month, day, year] = dateString.split('-');
        return dayjs(`${month}/${day}/${year}`);
    };

  	return (
		<>
			<div className='datepicker-section'>
			<Button className='datepicker-button' variant='contained'
				endIcon={<CalendarTodayIcon/>} disableElevation
				onClick={handleButtonClick}
				data-testid='datePickerButton'>
				{buttonLabel}
			</Button>
			
				<Modal
				open={openCalendarSelectionOption}
				onClose={handleClose}
				aria-labelledby='modal-title'
				aria-describedby='modal-description' className='daterange-modal'
				>
				<Card className='date-dropdown' > 
				<CardContent>
					<RadioGroup value={selectedOption} onChange={handleRadioChange}  >
						{radioOptions.map((option) => (
					<FormControlLabel
						key={option.value} 
						value={option.value}
						control={<Radio data-testid={option.value} />}
						label={option.label}
					/>
					))}
					
					<FormControlLabel
						value={DATE_RANGE_OPTIONS.CUSTOM_DATES}
						control={<Radio data-testid={DATE_RANGE_OPTIONS.CUSTOM_DATES} onClick={handleradioClick}/>}
						label={
						<div className='custom-radio'>
							<span className='custom-radio-text'  >
							 {DATE_RANGE_OPTIONS.CUSTOM_DATES}
							</span>
							<ArrowForwardIosIcon className='custom-radio-icon' />
						</div>
						}
					/>
					</RadioGroup>
				
				</CardContent>
				</Card>
				</Modal>
		
			
				<Modal
				open={showCalendar}
				onClose={handleClose}
				aria-labelledby='modal-title'
				aria-describedby='modal-description' className='calendar-model'
				>
						<Card className='calendar-card'>
						<CardContent>
						<form onSubmit={handleSubmit}>
								<LocalizationProvider dateAdapter={AdapterDayjs}>
									<div className='calendar-card-body'>
										<DatePicker
											label='Start Date' data-testid='Start Date'
											value={sessionstartdate ? convertDateFormat(sessionstartdate) : null}
											onChange={(date)=> handleStartDateChange(date)} onError={(error)=>setStartDateError(!!error)}
											TextFieldComponent={TextField} maxDate={today}
										/>
										<div className='to-text'>
											<span> to </span>
										</div>
										<DatePicker
											label='End Date' minDate={sessionstartdate ? convertDateFormat(sessionstartdate) : null} 
											data-testid='End Date' value={sessionenddate ? convertDateFormat(sessionenddate) : null}
											onChange={(date)=> handleEndDateChange(date)}  onError={(error)=> setEndDateError(!!error)}
											TextFieldComponent={TextField} maxDate={today}
										/>
									</div>
								</LocalizationProvider>
							<div className='calendar-card-footer'>
								<Button variant='text' onClick={handleCancel}> {CANCEL_TEXT} </Button>
								<Button className={ isSubmitDisabled ? 'applyDisable' : 'applyEnable'}
									variant='contained' type='submit' disabled={isSubmitDisabled}> {APPLY_TEXT} </Button>
							</div>
						</form>
						</CardContent></Card>
						</Modal>
		
			</div>
		</>
  	);
};
 
export default DateRangeButton;
